import { Trans } from '@lingui/react/macro';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@repo/videa-components/src/index';

import type { ZuubTreatmentHistory } from '@/@types/zuub/contracts';
import { useLocalizedFormatDate } from '@/modules/claims/freeClaims/state';

interface TreatmentHistoryTableProps {
  data: ZuubTreatmentHistory[];
}

export const TreatmentHistoryTable = ({ data }: TreatmentHistoryTableProps) => {
  const formatDate = useLocalizedFormatDate();

  return (
    <div className="vai-w-full vai-overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="vai-text-left vai-font-medium vai-text-muted-foreground vai-text-sm vai-uppercase">
              <Trans>Date</Trans>
            </TableHead>
            <TableHead className="vai-text-left vai-font-medium vai-text-muted-foreground vai-text-sm vai-uppercase">
              <Trans>Procedure</Trans>
            </TableHead>
            <TableHead className="vai-text-left vai-font-medium vai-text-muted-foreground vai-text-sm vai-uppercase">
              <Trans>Location</Trans>
            </TableHead>
            <TableHead className="vai-text-left vai-font-medium vai-text-muted-foreground vai-text-sm vai-uppercase">
              <Trans>Surface</Trans>
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((dateGroup) =>
            dateGroup.procedures.map((procedure, procedureIndex) => {
              const isLastInGroup =
                procedureIndex === dateGroup.procedures.length - 1;
              return (
                <TableRow
                  key={`${dateGroup.date}-${procedure.code}-${procedureIndex}`}
                  className={isLastInGroup ? '' : 'vai-border-b-0'}
                >
                  <TableCell className="vai-text-sm vai-text-foreground vai-py-2">
                    {procedureIndex === 0 ? formatDate(dateGroup.date, true) : ''}
                  </TableCell>
                  <TableCell className="vai-text-sm vai-text-foreground vai-py-2">
                    {procedure.code ||
                      procedure.category ||
                      procedure.name ||
                      ''}
                  </TableCell>
                  <TableCell className="vai-text-sm vai-text-foreground vai-py-2">
                    {procedure.location || ''}
                  </TableCell>
                  <TableCell className="vai-text-sm vai-text-foreground vai-py-2">
                    {procedure.surface || ''}
                  </TableCell>
                </TableRow>
              );
            }),
          )}
        </TableBody>
      </Table>
    </div>
  );
};
